import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({
  selector: 'app-approve-reject-button',
  styleUrls: ['./approve-reject-button.component.scss'],
  templateUrl: './approve-reject-button.component.html',
})
export class ApproveRejectButtonComponent implements AgRendererComponent {
  private params: any;
  public disabled = false;
  public isApproved: boolean;

  refresh(params: any): boolean {
    return undefined;
  }

  agInit(params: any): void {
    this.params = params;
    this.isApproved = this.params.data.approved;
  }

  public invoke() {
    this.params.context.componentParent.onActivateDeactivateClick(
      this.params.data,
    );
  }
}
